<template>
    <b-modal
        size="xl"
        title="Survey Results"
        ref="SurveyResults"
        @hidden="closeModal"
        hide-footer>
        <div id="survey-results" class="modal-form">
            <b-row class="align-items-end">
                <b-col md="4">
                    <p>Title</p>
                    <b-form-input v-model="survey_modal.view.title" disabled></b-form-input>
                </b-col>
                <b-col md="6" offset="2" class="text-right">
                    <b-button
                        variant="primary btn-export"
                        @click="exportSurvey">Export</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <div class="data-container">
                        <b-table show-empty
                            :empty-text="(loading) ? 'Loading data' : 'No data to show'"
                            :items="survey_modal.view.list"
                            :fields="fields"
                            responsive>
                            <template slot="accepted" slot-scope="data">

                                <template v-if="data.item.accepted === 1">
                                    <span class="py-1 px-3 border true">Yes</span>
                                </template>

                                <template v-else>
                                    No
                                </template>

                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="mt-1">
                        <span class="pagination-indicator">Showing {{ viewsurvey_pagination.currentFirstItem }} to {{ viewsurvey_pagination.currentLastItem }} of {{ viewsurvey_pagination.maxPage }} per page</span>
                    </div>
                </b-col>
                <b-col>
                    <b-pagination
                        hide-goto-end-buttons
                        align="right"
                        size="md"
                        class="custom-pagination"
                        :total-rows="(viewsurvey_pagination.totalPerPage > 0) ? viewsurvey_pagination.maxPage * viewsurvey_pagination.totalPerPage : 1"
                        :limit="(viewsurvey_pagination.totalPerPage > 0) ? 5 : 1"
                        :per-page="viewsurvey_pagination.totalPerPage"
                        @change="paginate">
                    </b-pagination>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

const fields = [
    
];

export default {
    name: "SurveyResults",
    props: ["open"],
    data() {
        return {
            fields: [
                {
                    key: "name",
                    label: "Customer Name",
                    sortable: true,
                    thClass: "text-left",
                    tdClass: "text-left"
                },
                {
                    key: "membership_id",
                    label: "Membership ID",
                    sortable: true
                },
                {
                    key: "mobile",
                    label: "Mobile No.",
                    sortable: true,
                    formatter: value => {
                        return "0" + value;
                    }
                },
                // {
                //     key: "store",
                //     sortable: true
                // },
                {
                    key: "accepted",
                    sortable: true,
                    tdClass: "text-center",
                    formatter: value => {
                        return value === 1 ? "Yes" : "No";
                    }
                },
                {
                    key: "submission_date",
                    sortable: true,
                    thClass: "text-left",
                    tdClass: "text-left",
                    formatter: value => {
                        return value
                            ? this.$moment(value).format("DD MMM YYYY HH:mm")
                            : null;
                    }
                }
            ]
        };
    },
    computed: {
        ...mapState("engagementSurvey", ["survey_modal", "loading", "viewsurvey_pagination"])
    },
    methods: {
        closeModal: function() {
            this.$store.commit("engagementSurvey/setModal", {
                type: "view",
                status: false,
                survey_id: null,
                target_segment_uuid: null,
                title: null,
                list: []
            });
        },

        view: function() {
            this.$store.dispatch("engagementSurvey/view", this.survey_modal.view);
        },

        paginate: async function(page) {
            let survey_id = this.survey_modal.view.survey_id;
            let target_segment_uuid = this.survey_modal.view.target_segment_uuid;
            this.$store.commit("engagementSurvey/loading", true);
            await this.$store
                .dispatch("engagementSurvey/view", {
                    survey_id: survey_id,
                    target_segment_uuid: target_segment_uuid,
                    page: page
                })
                .then(() => {
                    this.$store.commit("engagementSurvey/loading", false);
                });
        },

        exportSurvey: async function() {
            await this.$store.dispatch("engagementSurvey/export", {
                survey_id: this.survey_modal.view.survey_id,
                target_segment_uuid: this.survey_modal.view.target_segment_uuid
            });
        }
    },
    watch: {
        open: function(value) {
            if(value === true) {
                this.$refs.SurveyResults.show();
                this.view();
            } else {
                this.$refs.SurveyResults.hide();
            }
        }
    }
}
</script>
